import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { useMemo, useState, useEffect } from "react";
import { useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AddIcon } from "@chakra-ui/icons";
import DataNotFound from "common/components/notFoundData";
import Pagination from "common/components/pagination/Pagination";
import DateFormatter from "common/utils/dateFormater";
import AddMeeting from "./Addmeeting";
import { globalStyles } from "common/theme/styles";
import { constant } from "common/constant";
import useGlobalTable from "services/Crm/utils/tableInstance";
import { crmConstant } from "services/Crm/constant";
import 'common/assets/css/viewEdit.css'

export default function ColumnsTable(props) {
  const { columnsData, tableData, title, fetchData, action, setAction, access, allData, initialValues, lead, dynamic = false } = props;
  const buttonbg = useColorModeValue("gray.200", "white");
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const [meetingModel, setMeetingModel] = useState(false);
  const [gopageValue, setGopageValue] = useState();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageIndex, pageSize,
  } = useGlobalTable(columns, data);

  useEffect(() => {
    if (gopageValue === undefined && pageOptions.length < gopageValue) {
      setGopageValue(pageOptions.length);
    }
  }, [pageOptions, gopageValue]);

  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const param = useParams();
  const navigate = useNavigate();

     useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);

  return (
    <>
      <Box className="viewEditAccordian">
        <Box className="viewEditAccordianItem">
          <Box className="viewEditAccordianBtn">
            <Flex justify="space-between" flex="1" align="center">
              <Flex gap={"20px"} alignItems={"center"}>
                <Heading className="viewEditAccordianHeader" size="md">{title}</Heading>

              </Flex>

              <Button
                size="sm"
                onClick={() => navigate("/crm/meeting/createMeeting", {
                  state: {
                    initialValuesProp: initialValues,
                    view: lead ? constant.lead : dynamic ? initialValues?.dealName ? constant.deals : constant.accounts : constant.contact,

                  }
                },)}
                leftIcon={<AddIcon fontSize={"12px"} color={globalStyles.colors.iconDark} />}
                className="accordianAddBtn"
              >
                {constant.addNew}
              </Button>
            </Flex>
          </Box>
        </Box>
        <Box className="viewEditAccordianPannel" pb={4}>
          <Box overflowY={"auto"} className="table-container p0">
            <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px" className="lead-table-main">
              <Thead className="viewEditAccordian-tableHead">
                {headerGroups.map((headerGroup, index) => (
                  <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                    {headerGroup.headers.map((column, index) => (
                      <Th {...column.getHeaderProps(column.isSortable !== false && column.getSortByToggleProps())} key={index} borderColor={borderColor}>
                        <Flex justifyContent={column.center ? "center" : "start"} align="center" fontSize={{ sm: "14px", lg: "16px" }}>
                          <span style={{ textTransform: "capitalize", marginRight: "8px" }}>{column.render("Header")}</span>
                        </Flex>
                      </Th>
                    ))}
                  </Tr>
                ))}
              </Thead>
              <Tbody {...getTableBodyProps()}>
                {data.length === 0 ? (
                  <Tr>
                    <Td colSpan={columns.length} textAlign="center" className="nodataTd">
                      <Text fontSize="lg" color="gray.500">
                        {/* {crmConstant.noMeetingFound} */}
                        <DataNotFound title={"Meetings"} />
                      </Text>
                    </Td>
                  </Tr>
                ) : (
                  page.map((row, index) => {
                    prepareRow(row);
                    const rowLink = `/crm/meeting/${row.original._id}`;
                    return (
                      <Tr onClick={access?.view ? () => navigate(rowLink) : undefined} {...row?.getRowProps()} key={index}>
                        {row?.cells?.map((cell, index) => {
                          let data = "";
                          if (cell?.column.Header === "agenda") {
                            data = (
                              <Text
                                color="brand.600"
                                fontSize="sm"
                                fontWeight="700"
                              >
                                {cell?.value ? cell?.value : " - "}
                              </Text>
                            )
                          } else if (cell?.column.Header === crmConstant.MEETING_HEADERS.LOCATION) {
                            data = (
                              <Text color={textColor} fontSize="sm" fontWeight="700">
                                {cell?.value ? cell?.value : " - "}
                              </Text>
                            );
                          } else if (cell?.column.Header === crmConstant.MEETING_HEADERS.RELATED) {
                            data = (
                              <Text color={textColor} fontSize="sm" fontWeight="700">
                                {cell?.value ? cell?.value : " - "}
                              </Text>
                            );
                          } else if (cell?.column.Header === crmConstant.MEETING_HEADERS.DATE_TIME) {
                            data = (
                              <Text color={textColor} fontSize="sm" fontWeight="700">
                                {DateFormatter(cell?.value)}
                              </Text>
                            );
                          }
                          return (
                            <Td
                              {...cell?.getCellProps()}
                              key={index}
                              cursor="pointer"
                              fontSize={{ sm: "14px" }}
                              minW={{ sm: "150px", md: "200px", lg: "auto" }}
                              borderColor="transparent"
                            >
                              {data}
                            </Td>
                          );
                        })}
                      </Tr>
                    );
                  })
                )}
              </Tbody>
            </Table>
          </Box>
          {data.length > 5 && (
            <Pagination
              gotoPage={gotoPage}
              gopageValue={gopageValue}
              setGopageValue={setGopageValue}
              pageCount={pageCount}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              pageOptions={pageOptions}
              setPageSize={setPageSize}
              nextPage={nextPage}
              pageSize={pageSize}
              pageIndex={pageIndex}
            />
          )}
        </Box>
      </Box>

      <AddMeeting
        fetchData={fetchData}
        isOpen={meetingModel}
        onClose={setMeetingModel}
        from="lead"
        id={param.id}
        setAction={setAction}
      />
    </>
  );
}